// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pldd","content":"styles_content__37Huz"};